import React, { useState } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import CSSTransition from "deprecated-react-transition-group/CSSTransitionGroup";
import classnames from "classnames";

import GlobalPreferenceTooltip from "shared/containers/GlobalPreferenceTooltip";
import useGatekeeper from "shared/hooks/useGatekeeper";
import CarotIcon from "shared/components/svgs/carot.svg";
import ProfileMenu from "./ProfileMenu";

import { canShowGlobalPreferenceTooltip } from "shared/components/GlobalPreferenceTooltip/helpers";
import { selectedOptionOnNavBarEvent } from "routers/Desktop/NavBar/components/util/analytics";

import "./ProfileButton.scss";

const ProfileButton = ({
	displayName,
	thumbnail,
	isAlist,
	isFlagMod,
}) => {
	const [isMenuOpen, toggleMenu] = useState(false);
	const [needsDetailsReboarding] = useGatekeeper("NEEDS_DETAILS_REBOARDING");
	const location = useLocation();

	return (
		<div className="profile-button-container">
			<button
				className={classnames("profile-button", {
					"isOpen": isMenuOpen,
				})}
				onClick={() => {
					toggleMenu(!isMenuOpen);
					selectedOptionOnNavBarEvent("Profile Dropdown");
				}}
			>
				<div className="profile-button-inner-container">
					<div className="profile-button-details">
						<div className="profile-button-thumbnailwrapper">
							<img
								className="profile-button-thumbnail"
								src={thumbnail}
								alt="profile pic"
							/>
							{needsDetailsReboarding && <div className="profile-button-notification">!</div>}
						</div>
						<div
							className={classnames("profile-button-name", {
								"profile-button-name-alist": isAlist,
								"profile-button-name-free": !isAlist,
							})}
						>
							{displayName}
						</div>
						{isAlist && (
							<div className="profile-button-alist-badge">
								A-List
							</div>
						)}
					</div>
					<CarotIcon
						className={classnames("profile-button-carot-icon", {
							"profile-button-carot-icon--is-open": isMenuOpen,
						})}
					/>
				</div>

			</button>
			{canShowGlobalPreferenceTooltip(location.pathname) &&
				<GlobalPreferenceTooltip />
			}
			<CSSTransition
				transitionName="profile-menu"
				transitionAppear
				transitionAppearTimeout={200}
				transitionEnterTimeout={200}
				transitionLeaveTimeout={200}
			>
				{isMenuOpen && (
					<ProfileMenu
						key="profile-menu"
						isFlagMod={isFlagMod}
						onClose={() => toggleMenu(false)}
					/>
				)}
			</CSSTransition>
		</div>
	);
};

ProfileButton.propTypes = {
	displayName: PropTypes.string.isRequired,
	thumbnail: PropTypes.string.isRequired,
	isAlist: PropTypes.bool.isRequired,
	isFlagMod: PropTypes.bool.isRequired,
};

export default ProfileButton;



// WEBPACK FOOTER //
// ./src/routers/Desktop/NavBar/components/ProfileButton.jsx